import { Box, Tab, Tabs, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'

import PageContainer from '@/components/ui/containers/PageContainer'
import { MedicalActTemplates } from '@/features/medical-acts'

export function MedicalActTemplatesPage() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()

    const isRecordsTab = location.pathname.includes('/records')
    const basePath = location.pathname.startsWith('/super-admin') ? '/super-admin' : '/admin'

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        if (newValue === 0) {
            navigate(`${basePath}/medical-acts`)
        } else {
            navigate(`${basePath}/medical-acts/records`)
        }
    }

    return (
        <PageContainer>
            <Typography variant="h4" component="h1" gutterBottom>
                {t('page.admin.medicalActs.title', { defaultValue: 'Medical Acts' })}
            </Typography>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs value={isRecordsTab ? 1 : 0} onChange={handleTabChange}>
                    <Tab label={t('page.admin.medicalActs.tabs.templates', { defaultValue: 'Templates' })} />
                    <Tab label={t('page.admin.medicalActs.tabs.records', { defaultValue: 'Records' })} />
                </Tabs>
            </Box>
            <MedicalActTemplates />
        </PageContainer>
    )
}

export default MedicalActTemplatesPage

